import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import TOGGLE_ARTIST_FAVORITE_MUTATION from '../../../graphql/ToggleArtistFavorite';

class ToggleArtistFavorite extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: props.favorite,
    };
  }

  toggle = () => {
    const { mutate, id } = this.props;
    mutate({
      variables: {
        id,
      },
    })
      .then(() => {
        this.setState({ status: !this.state.status });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    return (
      <button onClick={this.toggle} className="favorite__button">
        <i className={`fa ${this.state.status ? 'fa-heart' : 'fa-heart-o'} fa-2x`} aria-hidden="true"/>
      </button>
    );
  }
}

ToggleArtistFavorite.propTypes = {
  favorite: PropTypes.bool,
  id: PropTypes.string.isRequired,
};

ToggleArtistFavorite.defaultProps = {
  favorite: false,
};

const withMutation = graphql(TOGGLE_ARTIST_FAVORITE_MUTATION);
export default withMutation(ToggleArtistFavorite);



// WEBPACK FOOTER //
// ./src/containers/Others/ToggleArtistFavorite/index.js